import React, { PureComponent } from "react";
import { Metric, Error } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class OverallProgress extends PureComponent {
  render() {
    const { data } = this.props.data;

    if (data.hasData === false) {
      return <Error minHeight={260} />;
    }

    return (
      <div className="row">
        <div className="col-md-4">
          <Heading size={3} className={""}>
            Total Cume Reach
          </Heading>
          <Metric {...data.total_cume_reach} size={"lg"} />

          <Heading size={4} className={"text-gray mt-2 mb-4"}>
            Cume Viewers to Date
          </Heading>

          <Heading size={5} className={"text-gray mt-2 mb-0"}>
            Same Day in ‘18
          </Heading>
          <Metric {...data.total_cume_reach_same_day_in_18} size={"sm"} />

          <Heading size={5} className={"text-gray mt-3 mb-0"}>
            Same Game Count in ‘18
          </Heading>
          <Metric
            {...data.total_cume_reach_same_game_count_in_18}
            size={"sm"}
          />
          <Heading size={5} className={"text-gray mt-3 mb-0"}>
            Estimate
          </Heading>
          <Metric {...data.total_cume_reach_estimate} size={"sm"} />
        </div>

        <div className="col-md-4">
          <Heading size={3} className={""}>
            AVG Daily TAD
          </Heading>
          <Metric {...data.avg_daily_tad} size={"lg"} />
          <Heading size={5} className={"text-gray mt-2 mb-0"}>
            Same Day in ‘18
          </Heading>
          <Metric {...data.avg_daily_tad_same_day_in_18} size={"sm"} />

          <Heading size={5} className={"text-gray mt-3 mb-0"}>
            Same Game Count in ‘18
          </Heading>
          <Metric {...data.avg_daily_tad_same_game_count_in_18} size={"sm"} />
          <Heading size={5} className={"text-gray mt-3 mb-0"}>
            Estimate
          </Heading>
          <Metric {...data.avg_daily_tad_estimate} size={"sm"} />
        </div>

        <div className="col-md-4">
          <Heading size={3} className={""}>
            AVG Rating Per Game
          </Heading>
          <Metric {...data.avg_rating_per_game} size={"lg"} />

          <Heading size={5} className={"text-gray mt-2 mb-0"}>
            Same Day in ‘18
          </Heading>
          <Metric {...data.avg_rating_per_game_same_day_in_18} size={"sm"} />

          <Heading size={5} className={"text-gray mt-3 mb-0"}>
            Same Game Count in ‘18
          </Heading>
          <Metric
            {...data.avg_rating_per_game_same_game_count_in_18}
            size={"sm"}
          />
          <Heading size={5} className={"text-gray mt-3 mb-0"}>
            Estimate
          </Heading>
          <Metric {...data.avg_rating_per_game_estimate} size={"sm"} />
        </div>
      </div>
    );
  }
}

export default OverallProgress;
